import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../services/AuthContext";

function AdminProtectedRoute({ children }) {
    const { user, loading, suspended } = useAuth();
    const location = useLocation();

    if (loading) {
        return <div className="app-loading">Authenticating…</div>;
    }
    if (suspended) {
        return <Navigate to="/account-suspended" replace />;
    }
    if (!user) {
        return (
            <Navigate
                to="/login"
                replace
                state={{ next: location.pathname + location.search }}
            />
        );
    }
    if (!user.is_admin) {
        return <Navigate to="/forbidden" replace />;
    }
    return children;
}

export default AdminProtectedRoute;
